import { render, staticRenderFns } from "./MNProviderTariffs.vue?vue&type=template&id=3220c7d1&"
import script from "./MNProviderTariffs.vue?vue&type=script&lang=ts&"
export * from "./MNProviderTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports